import API from 'services/api';

export const createReservationStatuses = ({ payload }: { payload: number[] }) =>
  API.post('/api/accommodation/calculation-statustypes', payload);
